import { application } from "./application";

import { VGlobal } from "./constants";

import { createLegacySingletonProxy, resolveLegacySingleton } from "./legacy/bootstrap";

export const vglobal = createLegacySingletonProxy((() => resolveLegacySingleton(VGlobal)));

application.global = vglobal;
//# sourceMappingURL=global.js.map